export function makeDuplicateName(oldName: string, namePostfix: string = "copy"){
    let copyName = "";
    if(oldName.includes(namePostfix)){
        let beforeName = oldName.split(namePostfix)[0];
        let afterName: any = oldName.split(namePostfix)[1];
        if(!isNaN(afterName)){
            afterName = Number(afterName) + 1;
            copyName = `${beforeName}${namePostfix}${afterName}`;
        }
    }

    if(!copyName){
        copyName = `${oldName} ${namePostfix}`
    }

    return copyName;
}
